import RangeSlider from '../range-slider/range-slider';
import {urlParam, debounce} from '../../_scripts/helpers';

export default class CategoryFilter {
	constructor(params) {
		this.root = document.querySelector(params.root);
	}
	init() {
		if (!this.root) return false;

		this._matchHTML();
		this._checkGETParams();
		this._initRangeSlider();
		this._submitBtnsHandler();
		this._categoriesInputsHandler();
		// this._calcModefCount();
		this._mobileFilterHandler();
	}

	_matchHTML() {
		this.priceInputs = [...this.root.querySelectorAll('[data-price-input]')];
		this.submitBtns = [...this.root.querySelectorAll('[data-category-filter-submit]')];
		this.categoriesInputs = [...this.root.querySelectorAll('[data-child-category-json]')];
		this.ajaxContainer = document.querySelector('[data-items-list]');
		this.modef = document.querySelector('#modef');
		this.mobileFilterBtn = document.querySelector('.filter_opener');
	}

	_initRangeSlider() {
		const rangeSlider = this.root.querySelector('[data-range-slider]');

		if (!rangeSlider) return false;

		this.rangeSlider = new RangeSlider({ root: '[data-range-slider]' });
		this.rangeSlider.init();
		this.rangeSlider.slider.on('update', (values, handle) => {
			this._onRangeSliderUpdate(values, handle);
		});

		// this.rangeSlider.slider.on('change', debounce((values, handle) => {
		// 	this._modefHandler(this.rangeSlider.root.closest('.bx_filter_parameters_box'));
		// 	this.modef.querySelector('#modef_num').style.display = 'none';
		// }, 250));

		this._priceInputsHandler();
	}

	_onRangeSliderUpdate(values, handle) {
		if (!this.priceInputs.length) return false;
		this.priceInputs[handle].value = values[handle];
	}

	_priceInputsHandler() {
		this.priceInputs.forEach((input, handle) => {

			input.addEventListener('change', e => {
				this.rangeSlider.slider.setHandle(handle, input.value);
			});

			input.addEventListener('keydown', e => {

				var values = this.rangeSlider.slider.get();
				var value = Number(values[handle]);

				// [[handle0_down, handle0_up], [handle1_down, handle1_up]]
				var steps = this.rangeSlider.slider.steps();

				// [down, up]
				var step = steps[handle];

				var position;

				// 13 is enter,
				// 38 is key up,
				// 40 is key down.
				switch (e.which) {

					case 13:
						this.rangeSlider.slider.setHandle(handle, input.value);
						break;

					case 38:

						// Get step to go increase slider value (up)
						position = step[1];

						// false = no step is set
						if (position === false) {
							position = 1;
						}

						// null = edge of slider
						if (position !== null) {
							this.rangeSlider.slider.setHandle(handle, value + position);
						}

						break;

					case 40:

						position = step[0];

						if (position === false) {
							position = 1;
						}

						if (position !== null) {
							this.rangeSlider.slider.setHandle(handle, value - position);
						}

						break;
				}
			});
		});
	}

	_submitBtnsHandler() {
		if (!this.submitBtns.length) return false;

		this.submitBtns.forEach(btn => {
			btn.addEventListener('click', e => {
				e.preventDefault();
				this._sendRequest();
			});
		});
	}

	_sendRequest() {
		let data = this._createFilterData(),
			str = JSON.stringify(data),
			self = this;

		$.ajax({
			url: '',
			data: {
				stocks_filter: encodeURIComponent(str)
			},
			type: 'GET',
			// dataType: 'json',
			beforeSend: function () {
				// if (this.ajaxContainer) this.ajaxContainer.classList.add('is-loading');
				window.location = this.url;
			},
			success: function (res) {
				// history.pushState(null, null, this.url);

				// if (self.ajaxContainer) {
				// 	self.ajaxContainer.innerHTML = res;

				// 	// Эта каша из Aspro
				// 	setTimeout(function(){
				// 		$('.catalog_block .catalog_item_wrapp .catalog_item .item-title').sliceHeight();
				// 		$('.catalog_block .catalog_item_wrapp .catalog_item .cost').sliceHeight();
				// 		$('.catalog_block .catalog_item_wrapp .item_info').sliceHeight();
				// 		$('.catalog_block .catalog_item_wrapp').sliceHeight({classNull: '.footer_button'});
				// 	}, 100)

				// 	self.ajaxContainer.classList.remove('is-loading');
				// }
			}
		});

		
	}

	_createFilterData() {
		let data = {
			CATEGORY: [],
			CATEGORY_FILTER: [],
			PRICE: {
				MIN: "",
				MAX: ""
			}
		};

		this.categoriesInputs.forEach(input => {
			if (input.checked) {
				let id = input.dataset.childCategoryJson,
					parentID = input.dataset.idCategory;

				if (typeof id !== 'undefined') {
					data.CATEGORY.push(JSON.parse(decodeURIComponent(id)));
				}

				if (typeof parentID !== 'undefined') {
					data.CATEGORY_FILTER.push(+parentID);
				}
				
			}
		});

		data.CATEGORY =  data.CATEGORY.flat();

		if (this.priceInputs.length) {
			data.PRICE.MIN = this.priceInputs[0].value;
			data.PRICE.MAX = this.priceInputs[1].value;
		}

		return data;
	}

	_checkGETParams() {
		if (urlParam('display') || urlParam('sort') || urlParam('stocks_filter') || urlParam('scrollToFilter')) {
			$([document.documentElement, document.body]).animate({
				scrollTop: ($(this.root).offset().top) - 100
			}, 0);
		}
	}

	_checkedInputsItemsLength() {
		return this.categoriesInputs.filter(input => input.checked).length;
	}

	_categoriesInputsHandler() {
		if (!this.categoriesInputs.length) return false;

		this.categoriesInputs.forEach(input => {
			input.addEventListener('change', e => {
				let name = input.name.replace('>', ''),
					label = this.root.querySelector(`[for=${name}]`);
				// this._modefHandler(label);
				// this._calcModefCount();
			})
		})
	}

	_modefHandler(element) {
		if (!element && !this.modef) return false;

		let elementPos = $(element).offset().top + element.offsetHeight / 2;

		this.modef.style.display = 'block';
		this.modef.style.top = `${elementPos - $(this.root).offset().top}px`;
	}

	_calcModefCount() {
		if (!this.modef) return false;
		let count = this._checkedInputsItemsLength();

		this.modef.querySelector('#modef_num').innerHTML = count;
		this.modef.querySelector('#modef_num').style.display = '';

		if (!count) this.modef.style.display = '';
	}

	_mobileFilterHandler() {
		if (!this.mobileFilterBtn) return false;

		this.mobileFilterBtn.addEventListener('click', e => {
			e.preventDefault();
			this.mobileFilterBtn.classList.toggle('opened');
			this.root.classList.toggle('is-openned');
		});

		let mql = window.matchMedia('(min-width: 991px)'),
			screenTest = e => {
				if (e.matches) {
					this.mobile = false;
					document.querySelector('.content-container__col--1').append(this.root);
				} else {
					this.mobile = true;
					document.querySelector('.content-container__col--2').append(this.root);
				}
			};

		screenTest(mql);
		mql.addListener(screenTest);
	}
}